<template>
<div :class="'outside-click-holder'">
  <div class="form-input-wrapper autocomplete-main-wrapper">
    <label class="form-label" :for="id">
      <span>{{ label!=undefined ? label : type}}</span
      ><span v-if="required">*</span>
    </label>
    <div class="autocomplete-wrapper">
      <input
        :class="['form-autocomplete', invalid?'invalid':'']"
        type="text"
        :name="name"
        :placeholder="placeholder"
        :required="required"
        @input="onChange(type)"
        v-model="search"
      />
      <div class="autocomplete-confirm" @click="checkIfStranka">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="10"
          viewBox="0 0 21 10"
        >
          <g>
            <g>
              <path
                fill="#3326ae"
                d="M20.94 4.303L16.26.026a.39.39 0 0 0-.427-.06.355.355 0 0 0-.232.354v2.737H.39a.379.379 0 0 0-.28.11.381.381 0 0 0-.11.28v2.347a.38.38 0 0 0 .11.28.38.38 0 0 0 .28.11h15.212v2.738c0 .163.077.281.231.354a.38.38 0 0 0 .427-.073l4.68-4.326a.4.4 0 0 0 0-.574z"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="results-selected-wrapper">
      <div
        v-for="(rs, key) in results_final"
        :key="key"
        class="result-selected"
      >
        <div class="remove-result" @click="removeSelectedResult(key, type)">
          <svg
            xlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
          >
            <g>
              <g>
                <path
                  fill="#eae9ee"
                  d="18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                />
              </g>
              <g>
                <path
                  fill="#191e2c"
                  d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                />
              </g>
            </g>
          </svg>
        </div>
        <div :class="'result-name rsn' + key + type">
          <span class="result-name-span">{{ results_final[key].name }} </span>
          <div class="result-status" v-if="results_final[key].status_ID == '0'">
            <span v-if="show_statuses">Status nije odabran</span>
          </div>
          <div class="result-status" v-else>
            <span v-for="(s, i) in statusi" :key="i">
              <span v-if="results_final[key].status_ID == s.id">{{
                s.naziv
              }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      id="autocomplete-results"
      v-show="false"
      :class="'autocomplete-results autocomplete-results-' + type"
    >
      <div class="loading" v-if="isLoading">
        {{ loadText }}
      </div>
      <div v-else v-for="(result, i) in results" :key="i">
        <div
          :class="
            'autocomplete-checkbox-wrapper autocomplete-checkbox-' +
            type +
            ' cwrap' +
            i
          "
          @click="selectCheckboxValue(i, type)"
        >
          <label
            :for="'autocomplete-result' + i"
            :value="result.link"
            :isfiz="result.is_fiz"
            :connection_status="result.connection_status"
            >{{ result.value }}</label
          >
          <div :id="'autocomplete-result' + i" class="custom-checkbox">
            <div class="check"></div>
          </div>
        </div>
      </div>
      <div v-if="show_statuses" class="status-dropdown-wrapper">
        <select
          v-model="status_ID"
          class="input-quick-select autocomplete-select"
          name="status"
          :id="inputType"
        >
          <option v-for="(s, i) in statusi" :key="i" :value="s.id">
            {{ s.naziv }}
          </option>
        </select>
      </div>
    </div>
    <!-- end autocomplete results -->

    <!-- ako input nije prazan i ako ne postoji osoba za autocomplete -->
    <span v-if="search.length" v-show="isUnavailable" class="unavailableText">
      {{ noResText }}
    </span>

    <v-dialog v-model="postojeca_stranka_protustranka" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{postojeci_dialog_text}}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="removePerson"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="leavePerson"> Dodaj </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</div>
</template>

<script>
import clickAnim from "@/plugins/anim_functions";
import $ from "jquery";
import gsap from "gsap";

export default {
  props: {
    name: String,
    type: String,
    label:String,
    id: String,
    required: String,
    vmodel: String,
    placeholder: String,
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    statusi: {
      type: Array,
      required: false,
      default: () => [],
    },
    start: Array,
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    invalid:false,
    st_ID: String,
  },
  data() {
    return {
      isOpen: false,
      results: [],
      results_selected: [],
      results_final: [],
      search: "",
      status_ID: this.st_ID != undefined ? this.st_ID : 1,
      isLoading: false,
      plcHolder: "Pretražite rezultate",
      loadText: "Učitava se...",
      noResText: "Nema dostupnih osoba.",
      DropDownClosed: true,
      carrier_selected: false,
      carrier_counter: 0,
      show_statuses: true,
      inputType:"",
      temp_osoba:null,
      postojeca_stranka_protustranka:false,
      postojeci_dialog_text:'',
      askingUser:false,
      temp_list:null,
    };
  },
  methods: {
    setValue() {
      if(this.start != undefined)
      {
        //   this.results_selected = this.start;
        this.results_final = this.start
        if (this.inputType == "clan-tima") {
          for (let i = 0; i < this.results_final.length; ++i) {
            if(this.$route.name == "ProjectsNew" || this.$route.name == 'ProjectEdit'){
              if (this.results_final[i].status_ID == '1') {
                //nositelj
                $("#"+this.inputType+" option[value='1']")
                  .attr("disabled", "disabled")
                  .siblings()
                  .removeAttr("disabled");
              }
            }
            else{
              if (this.results_final[i].status_ID == '2') {
                //nositelj
                $("#"+this.inputType+" option[value='2']")
                  .attr("disabled", "disabled")
                  .siblings()
                  .removeAttr("disabled");
              }
            }
          }
        }
      }
    },
    unableNositelj(){
        if (this.inputType == "clan-tima") {
          console.log(this.results_final);
          for (let i = 0; i < this.results_final.length; ++i) {
            if(this.$route.name == "ProjectsNew" || this.$route.name == 'ProjectEdit'){
              if (this.results_final[i].status_ID == '1') {
                //nositelj
                $("#"+this.inputType+" option[value='1']")
                  .attr("disabled", "disabled")
                  .siblings()
                  .removeAttr("disabled");
              }
            }
            else{
              if (this.results_final[i].status_ID == '2') {
                //nositelj
                $("#"+this.inputType+" option[value='2']")
                  .attr("disabled", "disabled")
                  .siblings()
                  .removeAttr("disabled");
              }
            }
          }
        }
    },
    onChange(tip) {
      this.$emit("input", this.search);

      if (this.isAsync) {
        this.isLoading = true;
      } else {
        this.filterResults();
        this.isOpen = true;
        if (this.results.length > 0) {
          gsap.to(".autocomplete-results-" + tip, 0, { display: "block", opacity:1});
        }
        else{
          gsap.to(".autocomplete-results-" + tip, 0, { display: "none", opacity:0});
        }
      }
    },
    filterResults() {
      // first uncapitalize all the things
      this.results = [];
      var tmpResults = this.items.filter((item) => {
        return item.value.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
      var sideRes = [];

      if (tmpResults.length > 0) {
        //usklađivanje s početnim
        tmpResults.forEach((p) => {
          if (p.value.toLowerCase().startsWith(this.search.toLowerCase())) {
            this.results.push(p);
          } else {
            sideRes.push(p);
          }
        });
        this.results = this.results.concat(sideRes);
        this.firstResult = this.results[0];
      } else {
        this.firstResult = "";
      }
      if (this.search === "") {
        this.results = [];
        this.firstResult = "";
      }
    },
    handleClickOutside() {
      this.isOpen = false;
      this.arrowCounter = -1;

      this.unCheckbox();
      gsap.to(".autocomplete-results", 0.25, { opacity: 0 });
      gsap.to(".autocomplete-results", 0.25, { display: "none" });

      this.search = "";
    },
    removePerson(){
      this.postojeca_stranka_protustranka = false;
      let temp_el = this.temp_osoba;
      this.temp_osoba = null;
      this.results_selected = this.results_selected.filter((el)=>el.UID != temp_el.UID);
      this.temp_list = this.temp_list.filter((el)=> el != temp_el);
      this.handleClickOutside();
    },
    leavePerson(){
      this.postojeca_stranka_protustranka = false;
      let temp_el = this.temp_osoba;
      this.temp_osoba = null;
      this.temp_list = this.temp_list.filter((el)=> el != temp_el);
    },
    checkStranka(obj){
      this.postojeci_dialog_text = "Osoba "+obj['name']+' je već protustranka na nekom predmetu! Jeste li sigurni da ju želite dodati kao stranku na ovaj predmet?'
      this.temp_osoba = obj;
      this.postojeca_stranka_protustranka = true;
    },
    checkIfStranka(){
      if (this.inputType != 'stranka') {
        this.displaySelectedResults();
      }
      else{
        if (this.results_selected == "") {
          alert("Odaberite jedan od rezultata, ili unesite novi");
        } else {
          this.temp_list = this.results_selected.filter((el)=>el.connection_status == 1);
        }
      }
    },
    selectCheckboxValue(i, tip) {
      if (
        $(".autocomplete-checkbox-" + tip + ".cwrap" + i).hasClass(
          "checkbox-clicked"
        )
      ) {
        gsap.to(
          ".autocomplete-checkbox-" + tip + " #autocomplete-result" + i,
          0.2,
          { border: "4px solid #cccccc" }
        );
        gsap.to(
          ".autocomplete-checkbox-" + tip + " #autocomplete-result" + i,
          0.4,
          { backgroundColor: "transparent" }
        );
        $(".autocomplete-checkbox-" + tip + ".cwrap" + i).removeClass(
          "checkbox-clicked"
        );
      } else {
        gsap.to(
          ".autocomplete-checkbox-" + tip + " #autocomplete-result" + i,
          0.2,
          { border: "3px solid #c8f8f2" }
        );
        gsap.to(
          ".autocomplete-checkbox-" + tip + " #autocomplete-result" + i,
          0.4,
          { backgroundColor: "#0acab1" }
        );
        $(".autocomplete-checkbox-" + tip + ".cwrap" + i).addClass(
          "checkbox-clicked"
        );
      }

      //clicked_result pushaj u array results_selected koji ćemo kasnije koristiti za prikaz u frontu
      if (
        $(".autocomplete-checkbox-" + tip + ".cwrap" + i).hasClass(
          "checkbox-clicked"
        )
      ) {
        //pospremi vrijednost na koju se kliknulo u clicked_result
        var clicked_result_value = $(
          ".autocomplete-checkbox-" + tip + ".cwrap" + i + " label"
        ).text();
        var clicked_result_uid = $(
          ".autocomplete-checkbox-" + tip + ".cwrap" + i + " label"
        ).attr("value");
        var clicked_result_isfiz = $(
          ".autocomplete-checkbox-" + tip + ".cwrap" + i + " label"
        ).attr("isfiz");
        var clicked_result_con_stat = $(
          ".autocomplete-checkbox-" + tip + ".cwrap" + i + " label"
        ).attr("connection_status");
        var obj = {};
        //dodaj clicked vrijednosti
        obj["UID"] = clicked_result_uid;
        obj["name"] = clicked_result_value;
        obj["is_fiz"] = clicked_result_isfiz; 
        obj["connection_status"] = clicked_result_con_stat;

        this.results_selected.push(obj);
      } else {
        //makni clicked vrijednost ako je već clicked
        // const index = this.results_selected.indexOf(clicked_result_value)
        // if (index > 0) { this.results_selected.splice(index, 1) }

        //** makni kliknutoga van iz results selected *** /////
        var removeResultValue = $(
          ".autocomplete-checkbox-" + tip + ".cwrap" + i + " label"
        ).text();
        var i = 0;
        while (i < this.results_selected.length) {
          //mičemo ovog koji je kliknuti
          var x = removeResultValue;
          if (this.results_selected[i].name == x) {
            // makni rezultat iz results_selected
            this.results_selected.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    },

    //vizualno odselektiraj sve checkboxove i makni kliknute vrijednosti iz results_selected
    unCheckbox() {
      gsap.to(".custom-checkbox", 0.2, { border: "4px solid #cccccc" });
      gsap.to(".custom-checkbox", 0.4, { backgroundColor: "transparent" });
      $(".autocomplete-checkbox-wrapper").removeClass("checkbox-clicked");

      this.results_selected = [];
      this.carrier_counter = 0;
    },

    displaySelectedResults() {
      if (this.results_selected == "") {
        alert("Odaberite jedan od rezultata, ili unesite novi");
      } else {
        // svakom selektiranom rezultatu dodjeljuje odabrani status
        for (let i = 0; i < this.results_selected.length; ++i) {
          this.results_selected[i].status_ID = this.status_ID;
        }

        //provjeri da li postoji samo jedan selektirani rezultat sa statusom nositelj
        for (let i = 0; i < this.results_selected.length; ++i) {
          if(this.$route.name == "ProjectsNew" || this.$route.name == 'ProjectEdit'){
            if (this.status_ID == "1") {
              //nositelj
              this.carrier_counter++;
            }
          }
          else{
            if (this.status_ID == "2") {
              //nositelj
              this.carrier_counter++;
            }
          }
        }
        if (this.carrier_counter > 1) {
          alert("Samo jedna osoba može imati status nositelj");
          this.unCheckbox();
        } else {
          //pusha selektirane rezultate u result_final
          this.results_selected.forEach((element) =>
            this.results_final.push(element)
          );

          //miče selektirane rezultate iz items da se ti rezultati ne bi kasnije pojavljivali u rezultatima i uzrokovali duplikate
          for (var i = this.items.length - 1; i >= 0; i--) {
            for (var j = 0; j < this.results_selected.length; j++) {
              if (
                this.items[i] &&
                this.items[i].link.toString() === this.results_selected[j].UID
              ) {
                this.items.splice(i, 1);
              }
            }
          }

          //unesi ime iz prvog rezultata iz results_final u store koji ćemo kasnije koristiti kod prijedloga kreiranja imena predmeta
          if (this.inputType == "stranka" && this.$store.state.ime_predmeta.ime_stranke == "") {
            this.$store.state.ime_predmeta.ime_stranke =
              this.results_final[0].name;
          }
          if (this.inputType == "protustranka" && this.$store.state.ime_predmeta.ime_protustranke == "") {
            this.$store.state.ime_predmeta.ime_protustranke =
              this.results_final[0].name;
          }

          var tl = new gsap.timeline();
          tl.to(".autocomplete-results", 0.25, { opacity: 0 });
          tl.to(".autocomplete-results", 0, { display: "none" });
          tl.to(".results-selected-wrapper", 0, { display: "flex" });
          tl.to(".results-selected-wrapper", 0.25, { opacity: 1 });

          this.unCheckbox();

          this.search = "";

          setTimeout(() => {
            this.results = [];
          }, 500);

          //provjeri da li postoji rezultat sa statusom nositelj results final i onemogući ponovno biranje
          for (let i = 0; i < this.results_final.length; ++i) {
            if (this.inputType == "clan-tima") {
              if(this.$route.name == "ProjectsNew" || this.$route.name == 'ProjectEdit'){
                if (this.status_ID == "1") {
                  //nositelj
                  $("#"+this.inputType+" option[value='1']")
                    .attr("disabled", "disabled")
                    .siblings()
                    .removeAttr("disabled");
                  this.status_ID = "0";
                }
              }
              else{
                if (this.status_ID == "2") {
                  //nositelj
                  $("#"+this.inputType+" option[value='2']")
                    .attr("disabled", "disabled")
                    .siblings()
                    .removeAttr("disabled");
                  this.status_ID = "0";
                }
              }
            }
          }
        }
      }
    },

    removeSelectedResult(key, tip) {
      var removeResultValue = $.trim(
        $(".rsn" + key + tip + " .result-name-span").text()
      );
      var ifStatusNositelj = $.trim(
        $(".rsn" + key + tip + " .result-status span").text()
      );
      //vrati clicknuti value par natrag u items da bude vidljiv među rezultatima

      // remove clicked value pair from final object;
      var i = 0;
      while (i < this.results_final.length) {
        //makni imena iz store-a koje koristimo kod prijedloga kreiranja imena predmeta

        if (
          (this.inputType == "stranka" || this.inputType =="stranka_project") &&
          removeResultValue == this.$store.state.ime_predmeta.ime_stranke
        ) {
          this.$store.state.ime_predmeta.ime_stranke = "";
        }
        if (
          this.inputType == "protustranka" &&
          removeResultValue == this.$store.state.ime_predmeta.ime_protustranke
        ) {
          this.$store.state.ime_predmeta.ime_protustranke = "";
        }

        //ako se vraća rezultat sa statusom nositelj onda bi trebali u drop statusa vratiti nositelj da se ponovo može birati
        if (
          ifStatusNositelj == "NositeljNositelj" &&
          this.results_final[i].name == removeResultValue
        ) {
           $("#"+this.inputType+" option[value='2']").removeAttr("disabled");
        }

        if (
          ifStatusNositelj == "VoditeljVoditelj" &&
          this.results_final[i].name == removeResultValue
        ) {
           $("#"+this.inputType+" option[value='1']").removeAttr("disabled");
        }
        //mičemo ovog koji je kliknuti
        var x = removeResultValue;
        if (this.results_final[i].name == x) {
          //vrati clicknuti value par natrag u items da bude vidljiv među rezultatima za ponovo pretraživanje
          var obj = {};
          obj["link"] = this.results_final[i].UID;
          obj["value"] = this.results_final[i].name;
          obj["is_fiz"] = this.results_final[i].is_fiz;
          if (this.inputType == "stranka" || this.inputType == "protustranka" || this.inputType == "Drugi_sudionici") {
            obj["connection_status"] = this.results_final[i].connection_status;
          }
          this.items.push(obj);
          //
          // makni rezultat iz results_final
          this.results_final.splice(i, 1);
        } else {
          ++i;
        }
      }

      this.search = "";
    },

    selectStatus(i) {
      $(".sid" + i).addClass("status-selected");
      $(".status:not(.sid" + i + ")").removeClass("status-selected");
      this.status_ID = $.trim($(".sid" + i).text());
      if(this.$route.name == "ProjectsNew" || this.$route.name == 'ProjectEdit'){
        if (this.status_ID == "1") {
          this.carrier_selected = true;
        } else {
          this.carrier_selected = false;
        }
      }
      else{
        if (this.status_ID == "2") {
          this.carrier_selected = true;
        } else {
          this.carrier_selected = false;
        }
      }
    },
  },
  watch: {
    items: function (val, oldValue) {
      // actually compare them
      if (val.length !== oldValue.length) {
        this.results = val;
        this.isLoading = false;
      }
    },
    temp_list: function(){
      if(this.temp_list != null && this.temp_list.length > 0){
        this.checkStranka(this.temp_list[0]);
      }
      else if(this.temp_list != null && this.temp_list.length == 0 && this.results_selected.length > 0){
        setTimeout(() => {
          this.displaySelectedResults();
        }, 100);
      }
      else if(this.temp_list != null && this.temp_list.length == 0 && this.results_selected.length == 0){

          this.unCheckbox();
      }
    },
  },
  computed: {
    isUnavailable() {
      return this.search !== "" && this.results.length === 0;
    },
  },
  mounted() {
    //definiranje jezika teksta
    if (this.$route.path.includes("/en")) {
      this.plcHolder = "search documents";
      this.loadText = "Loading results...";
      this.noResText = "There is no available documents.";
    }

    //*** ANIMACIJE */

    //autocomplete click animation (vučemo iz plugina)
    this.clickAnim(".autocomplete-confirm");

    //*** END ANIMACIJE */

    //logika ako je nadležno tijelo
    let vm = this;
    vm.$nextTick(function () {
      this.inputType = vm.id;
      setTimeout(this.setValue, 1000);
      var tl = new gsap.timeline();
      tl.to(".autocomplete-results", 0.25, { opacity: 0 });
      tl.to(".autocomplete-results", 0, { display: "none" });
      tl.to(".results-selected-wrapper", 0, { display: "flex" });
      tl.to(".results-selected-wrapper", 0.25, { opacity: 1 });
      if (this.inputType == "nadlezna-tijela" || this.inputType == "clanovi-tima-eventi") {
        this.show_statuses = false;
      }
    });
  },
  destroyed() {
    // document.removeEventListener("click", this.handleClickOutside);
  },
  created(){
    var _this = this;
    $('.v-application--wrap').click(function (e) {
      var container = $(".outside-click-holder")
      var dialog = $(".v-dialog__content")
      if(!container.is(e.target) && container.has(e.target).length === 0 && !dialog.is(e.target) && dialog.has(e.target).length === 0) {
        _this.handleClickOutside();
      }
    });
  },
  beforeDestroy() {
      $('.v-application--wrap').off();
  },
};
</script>

<style>
</style>
